// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"settingsPaymentMeanEditView_form-wrapper__1rhX1"};